// extracted by mini-css-extract-plugin
module.exports = {"skyscraper":"i9LU13","placement":"WMRp6d"};